module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "externalDash"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ApplicationDashTable', {
    attrs: {
      "level": "external",
      "url": _vm.applications_url
    }
  }), _vm._v(" "), _c('div', [_c('LicenceDashTable', {
    attrs: {
      "level": "external",
      "url": _vm.licences_url
    }
  }), _vm._v(" "), _c('ReturnDashTable', {
    attrs: {
      "level": "external",
      "url": _vm.returns_url
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "well well-sm"
  }, [_c('p', [_vm._v("\n                    Welcome to the Wildlife Licensing online system dashboard."), _c('br'), _c('br'), _vm._v(" Here you can access your existing licences, view any applications in progress, lodge new"), _c('br'), _vm._v(" applications or submit information required to comply with conditions listed\n                    on your licence\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2468a65e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/external/dashboard.vue
// module id = 939
// module chunks = 0